module.exports = __webpack_public_path__ + "static/media/happy-certificate.e8bafca2.jpg";